import { render, staticRenderFns } from "./_Offset.vue?vue&type=template&id=2f60e6b7&"
import script from "./_Offset.vue?vue&type=script&lang=js&"
export * from "./_Offset.vue?vue&type=script&lang=js&"
import style0 from "./_Offset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports